<div class="header">
    <h2>{{ 'schools.modal.view.title' | translate }}</h2>
    <button class="close" type="button" [attr.aria-label]="'common.close' | translate" data-test="schools-view-close" (click)="close()">
        <i class="pi pi-times"></i>
    </button>
</div>

@if (loading() !== false) {
    <div class="loading">
        <i class="pi pi-spin pi-spinner"></i>
    </div>
} @else if (error()) {
    <app-unavailable [message]="'schools.error.unavailable' | translate" />
} @else if (school(); as school) {
    <div class="body">
        <div class="entity-header">
            <div class="entity-identity">
                <h1>{{ school.name }}</h1>
                <span class="subtitle">{{ school.shortName }}</span>
            </div>
        </div>

        <div class="section">
            <h2>{{ 'schools.form.description' | translate }}</h2>
            @if (school.description) {
                <p class="description">{{ school.description }}</p>
            } @else {
                <p class="description empty">{{ 'common.notProvided' | translate }}</p>
            }

            <div class="field">
                <span class="label">{{ 'schools.form.rollNumber' | translate }}</span>
                @if (school.rollNumber) {
                    <span class="value">{{ school.rollNumber }}</span>
                } @else {
                    <span class="value empty">{{ 'common.notProvided' | translate }}</span>
                }
            </div>
        </div>

        <div class="section">
            <h2>{{ 'schools.fieldset.contact' | translate }}</h2>
            <div class="field">
                <span class="label">{{ 'schools.form.contactEmail' | translate }}</span>
                @if (school.contactEmail) {
                    <a class="value" [href]="'mailto:' + school.contactEmail">{{ school.contactEmail }}</a>
                } @else {
                    <span class="value empty">{{ 'common.notProvided' | translate }}</span>
                }
            </div>
        </div>

        <div class="section">
            <h2>{{ 'schools.fieldset.courses' | translate }}</h2>
            <app-entity-list [ids]="school.courseIds" type="course" emptyKey="schools.courses.empty" />
        </div>

        <div class="section">
            <h2>{{ 'schools.fieldset.address' | translate }}</h2>
            <div class="field">
                <span class="label">{{ 'schools.form.street' | translate }}</span>
                @if (school.address.street) {
                    <span class="value">{{ school.address.street }}</span>
                } @else {
                    <span class="value empty">{{ 'common.notProvided' | translate }}</span>
                }
            </div>
            <div class="row">
                <div class="field">
                    <span class="label">{{ 'schools.form.postalCode' | translate }}</span>
                    @if (school.address.postalCode) {
                        <span class="value">{{ school.address.postalCode }}</span>
                    } @else {
                        <span class="value empty">{{ 'common.notProvided' | translate }}</span>
                    }
                </div>
                <div class="field">
                    <span class="label">{{ 'schools.form.city' | translate }}</span>
                    @if (school.address.city) {
                        <span class="value">{{ school.address.city }}</span>
                    } @else {
                        <span class="value empty">{{ 'common.notProvided' | translate }}</span>
                    }
                </div>
            </div>
            <div class="field">
                <span class="label">{{ 'schools.form.country' | translate }}</span>
                @if (school.address.country) {
                    <span class="value">{{ school.address.country | countryName }}</span>
                } @else {
                    <span class="value empty">{{ 'common.notProvided' | translate }}</span>
                }
            </div>
        </div>

        <div class="section">
            <h2>{{ 'schools.fieldset.importLearners' | translate }}</h2>
            <app-import-learners [schoolId]="school.id" />
        </div>
    </div>

    <div class="footer">
        <app-delete-button [schoolId]="school.id" [saving]="saving()" testId="schools-view-delete" />
        <p-button [label]="'schools.detail.edit' | translate" icon="pi pi-pencil" data-test="schools-view-edit" (onClick)="onEdit()" />
    </div>
}
